import { render, staticRenderFns } from "./courseActivation.vue?vue&type=template&id=5167a7f6&scoped=true&"
import script from "./courseActivation.vue?vue&type=script&lang=ts&"
export * from "./courseActivation.vue?vue&type=script&lang=ts&"
import style0 from "./courseActivation.vue?vue&type=style&index=0&id=5167a7f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167a7f6",
  null
  
)

export default component.exports